// Central content constants for the Cranio marketing landing page.
// Ported from design/landing.jsx + design/lighting-stage.jsx.

export const SUPPORT_EMAIL = 'support@drawgestures.com';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/asaro-head-study/id6775111632';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.drawgestures.araso.headstudy';

export interface Feature {
  k: string;
  t: string;
  s: string;
}

export const FEATURES: Feature[] = [
  {
    k: '01',
    t: 'Sculpt with light',
    s: 'Drag up to five lights around the head. Tune intensity, hue and temperature and watch the form turn under them.',
  },
  {
    k: '02',
    t: 'Find the angle',
    s: 'Tilt, side and turn on three independent axes. Save any view you find as a clean reference shot.',
  },
  {
    k: '03',
    t: 'Seven models, one studio',
    s: 'Heads, skull, baby, and full male and female figures. Switch between them mid-session without losing your lighting.',
  },
  {
    k: '04',
    t: 'Any surface finish',
    s: 'Bronze, marble, clay, wax and more — drop a material on any model to study how light reads on it.',
  },
];

export interface ModelEntry {
  id: string;
  name: string;
  sub: string;
  img: string;
  pro?: boolean;
}

// Mirrors HeadModelCatalog in the app
// (composeApp/.../presentation/model/HeadModel.kt). Previews are the same
// renders shipped as the in-app model thumbnails.
export const MODELS: ModelEntry[] = [
  { id: 'asaro', name: 'Asaro', sub: 'Planes · Loomis', img: '/models/asaro.png' },
  { id: 'stylized-head', name: 'Stylized Head', sub: 'Construction · head', img: '/models/stylized-head.png', pro: true },
  { id: 'stylized-bust', name: 'Stylized Bust', sub: 'Construction · bust', img: '/models/stylized-bust.png' },
  { id: 'skull', name: 'Skull', sub: 'Cranium · planes', img: '/models/skull.png', pro: true },
  { id: 'baby', name: 'Baby', sub: 'Infant · planes', img: '/models/baby.png', pro: true },
  { id: 'male-body', name: 'Male Body', sub: 'Figure · planes', img: '/models/male-body.png', pro: true },
  { id: 'female-body', name: 'Female Body', sub: 'Figure · planes', img: '/models/female-body.png', pro: true },
];

export interface Plan {
  id: string;
  name: string;
  price: string;
  period: string;
  sub: string;
  cta: string;
  fine: string;
  best?: boolean;
  badge?: string;
}

export const PLANS: Plan[] = [
  {
    id: 'yearly',
    name: 'Annual',
    price: '$2.99',
    period: '/ year',
    sub: 'Billed yearly · no monthly charges',
    cta: 'Go Annual',
    fine: '$2.99/yr · cancel anytime.',
    best: true,
  },
  {
    id: 'lifetime',
    name: 'Lifetime',
    price: '$9.99',
    period: 'once',
    sub: 'Pay once · yours forever',
    cta: 'Unlock lifetime',
    fine: 'One-time payment. No subscription.',
  },
];

export const PRO_FEATURES: string[] = [
  'Export & share in 4K',
  'Every head model',
  'All surface finishes',
  'Pro lighting rigs — 5 lights',
];
